import create from 'zustand';

type RestrictClassModalState = {
  showRestrictClassModal: boolean;
  setShowRestrictClassModal: (val: boolean) => void;
  showJoinStatusMessage: string;
  setShowJoinStatusMessage: (val: string) => void;
};

const useRestrictClassModalStore = create<RestrictClassModalState>(set => ({
  showRestrictClassModal: false,
  showJoinStatusMessage: '',
  setShowRestrictClassModal: (val: boolean) =>
    set({showRestrictClassModal: val}),
  setShowJoinStatusMessage: (val: string) => set({showJoinStatusMessage: val}),
}));

export default useRestrictClassModalStore;
